import type { Notification } from 'types/common/notification';

const unknownValidationError: Notification = {
  id: 'form/unknownValidationError',
  type: 'error',
  content: 'An error occurred validating the form. Our support has been notified.',
};

const NOTIFICATION_FORM = { unknownValidationError };

export default NOTIFICATION_FORM;
